<a routerLink="login">
    <img alt="" class="logo" src="../../../app/assets/acura/acura-logo-extended.svg">
</a>